export const PerformanceLevels = {
	REDUCIDO: 1,
	PROMETEDORAS: 2,
	ELITES: 3
}

export const IndexLevels = {
	BAJO: 1,
	MEDIO: 2,
	ALTO: 3
}

export const PerformanceGroups = {
	MINERAS: 1,
	CONEXAS: 2,
}